/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function RelativeAbroad() {
    const tableName = 'RelativeAbroad';
    const [dataList, setData] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
    }, [candidate_id]);

    return (
        <>
            <div>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.Box>
                            <h4>Country</h4>
                            <h4>Region</h4>
                            <S.Value>{data?.country}</S.Value>
                            <S.Value> {data?.region}</S.Value>
                            <h4>Residence Status</h4>
                            <h4>Relation</h4>
                            <S.Value>{data?.residency_status}</S.Value>
                            <S.Value> {data?.relation}</S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
        </>
    );
}
